import { render, staticRenderFns } from "./ReceiptOrder.vue?vue&type=template&id=9fa23000&scoped=true&"
import script from "./ReceiptOrder.vue?vue&type=script&lang=js&"
export * from "./ReceiptOrder.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ReceiptOrder-pc.css?vue&type=style&index=0&id=9fa23000&scoped=true&lang=css&"
import style1 from "../assets/css/ReceiptOrder-phone.css?vue&type=style&index=1&id=9fa23000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa23000",
  null
  
)

export default component.exports